// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../../assets/stylesheets/viewports.m.css\"","mobile":"768px","wrapper":"authors-list-m__wrapper__z8npD","linkWrapper":"authors-list-m__linkWrapper__35Ttf"};